import React, { useState } from "react";
import { checkIsArrayEmpty } from "features/Common/modules/DataTypes/utils/Array.utils";
import { useAccountStore } from "features/Account/store/useAccountStore";
import { baseApiClient } from "data/modules/api/api.client";
import { SUBSCRIPTIONS_APIS } from "features/MySubscriptions/constants/MySubscriptions.constants";
import { FEATURE_KEYS } from "features/Account/Account.constants";
import { isRequestSuccessful } from "utils/Utils";
import { notification_color_keys, useNotifications } from "utils/hooks";
import { SOMETHING_WENT_WRONG } from "constants/displayStrings";
import { logError } from "utils/error";
import { Button } from "@material-ui/core";
import { ReactComponent as AutoFixHigh } from "assets/vectors/autoFixHigh.svg";

export const WhitelabelLockCta = ({ onClose }) => {
  const { notify } = useNotifications();
  const whitelabelPlans = useAccountStore((state) => state.whitelabelPlans);
  const setWhitelabelPlans = useAccountStore(
    (state) => state.setWhitelabelPlans
  );
  const setShowWhitelabelPlansModal = useAccountStore(
    (state) => state.setShowWhitelabelPlansModal
  );

  const [processing, setProcessing] = useState(false);

  const ctaText = processing ? "..." : "Choose plan";

  const openWhitelabelPlansModal = async (e) => {
    try {
      if (checkIsArrayEmpty(whitelabelPlans)) {
        setProcessing(true);
        const response = await baseApiClient.get(
          SUBSCRIPTIONS_APIS.SUBSCRIPTIONS_PLANS,
          { params: { feature_key: FEATURE_KEYS.whitelabel } }
        );
        if (isRequestSuccessful(response?.status)) {
          const [whitelabelSubscriptionPlan] =
            response?.data?.data?.subscription_plans ?? [];

          if (!checkIsArrayEmpty(whitelabelSubscriptionPlan?.plans)) {
            setWhitelabelPlans(whitelabelSubscriptionPlan?.plans);
            onClose(e);
            return setShowWhitelabelPlansModal(true);
          }
        }
        notify(SOMETHING_WENT_WRONG, notification_color_keys.error);
      } else {
        onClose(e);
        setShowWhitelabelPlansModal(true);
      }
    } catch (error) {
      logError({ error, when: "openWhitelabelPlansModal" });
      notify(SOMETHING_WENT_WRONG, notification_color_keys.error);
    } finally {
      setProcessing(false);
    }
  };

  return (
    <>
      <Button
        onClick={openWhitelabelPlansModal}
        fullWidth
        className="tw-bg-[linear-gradient(212.58deg,#7365cd_14.79%,#40329a_98.64%)] !tw-text-white tw-min-h-[42px] !tw-normal-case"
      >
        <AutoFixHigh className="tw-mr-1 [filter:brightness(0)_invert(1)] tw-h-[13.5px]" />
        <strong className="tw-text-base">{ctaText}</strong>
      </Button>
    </>
  );
};
